import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import { createStore, compose as reduxCompose } from 'redux'

import { QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import './styles/index.sass'
import {
  AuthContextProvider,
  ModalsProvider,
  ChuckContextProvider
} from './contexts'
import { init as initQueryClient } from './helpers/ReactQueryClient'
import App from './routes/app'
import reducers from './reducers'
import { ThemeContextProvider } from '@gopeerproject/ui-kit'
import { ModalContextProvider } from '@gopeerproject/web-kit'

export const queryClient = initQueryClient()
const compose =
  (process.env.NODE_ENV === 'development' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  reduxCompose

const store = createStore(reducers, {}, compose())

ReactDOM.render(
  <Provider store={store}>
    <ModalsProvider>
      <Router>
        <QueryClientProvider client={queryClient}>
          <ChuckContextProvider>
            <AuthContextProvider>
              <ThemeContextProvider forcedColorScheme='dark'>
                <ModalContextProvider>
                  <App />
                </ModalContextProvider>
              </ThemeContextProvider>
            </AuthContextProvider>
          </ChuckContextProvider>

          <ReactQueryDevtools
            initialIsOpen={false}
            position={'bottom-right'}
            panelProps={{
              style: {
                zIndex: 999999,
                maxHeight: '100%',
                height: '100%',
                width: '40%'
              }
            }}
            closeButtonProps={{ style: { zIndex: 9999999 } }}
          />
        </QueryClientProvider>
      </Router>
    </ModalsProvider>
  </Provider>,

  document.getElementById('app')
)
